import { Badge } from '@/components/ui/badge';
import type { DimensionsSubType, FieldDataType, LengthUnit, SelectOption } from '@rock/types';
import type { FC } from 'react';

export const FieldDataTypeBadge: FC<{
    dataType: FieldDataType;
    dimensionsSubType?: DimensionsSubType;
    defaultLengthSelection?: LengthUnit;
    options?: SelectOption[];
}> = ({ dataType, dimensionsSubType, defaultLengthSelection, options }) => {
    let label: string = dataType;
    if (dataType === 'dimensions' && dimensionsSubType) {
        label += `/${dimensionsSubType}`;
        if (dimensionsSubType !== 'sqft' && defaultLengthSelection) {
            label += `/${defaultLengthSelection}`;
        }
    }
    if (dataType === 'select' && options) {
        label += ` (${options.length})`;
    }

    return (
        <Badge variant="outline" className="font-normal">
            {label}
        </Badge>
    );
};
